import React from "react";
import { useLoginCallback } from "@/lib/auth/useLoginCallback";
import "./AuthPages.scss";

interface LoginCallbackProps {
  clientType: "consumer" | "banker";
}

export const LoginCallback: React.FC<LoginCallbackProps> = ({ clientType }) => {
  const { messages, error } = useLoginCallback(clientType);

  if (error) {
    return (
      <div className="login-callback-error">
        <h2>Authentication Error</h2>
        <p>There was an issue processing your login. Please try again.</p>
        <button onClick={() => (window.location.href = "/")}>Return to Home</button>
      </div>
    );
  }

  return (
    <section className="login-callback">
      <div className="login-callback__content">
        <h2>Processing your login...</h2>
        <p>Please wait while we complete your authentication.</p>
        {messages && <p className="login-callback__message">{messages}</p>}
      </div>
    </section>
  );
};
